/**
 * Loads js scripts and config for viafoura dev envs on AWS/Kubernetes
 *
 * Needed because webpack complains otherwise
 */
import '@/polyfills.js';
import { getEnv } from './env.js';
import { getConfig } from './config.js';
import { release } from './conf/config.release.js';


const env = getEnv();
const localConfig = getConfig(env);

const config = {
    ...release(),
    ...localConfig,
};

export { config, config as default };
